import React, { useEffect, useState } from "react";

const MaintenancePage = () => {
  const [dots, setDots] = useState(".");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? "." : prev + "."));
    }, 600);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #065a4e 0%, #043d34 50%, #022820 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
        padding: "24px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Subtle background pattern */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "radial-gradient(circle at 20% 20%, rgba(207,169,92,0.08) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(207,169,92,0.06) 0%, transparent 50%)",
          pointerEvents: "none",
        }}
      />

      {/* Card */}
      <div
        style={{
          background: "rgba(255, 254, 253, 0.97)",
          borderRadius: "20px",
          padding: "48px 40px",
          maxWidth: "480px",
          width: "100%",
          textAlign: "center",
          boxShadow:
            "0 32px 64px rgba(0,0,0,0.3), 0 0 0 1px rgba(207,169,92,0.15)",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Logo / Brand mark */}
        <div
          style={{
            width: "72px",
            height: "72px",
            borderRadius: "18px",
            background: "linear-gradient(135deg, #065a4e, #0a8a78)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 28px",
            boxShadow: "0 8px 24px rgba(6,90,78,0.35)",
          }}
        >
          {/* Wrench + gear SVG icon */}
          <svg
            width="36"
            height="36"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#cfa95c"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="3" />
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
            <path d="M4.93 4.93a10 10 0 0 0 0 14.14" />
            <path d="M12 2v2" />
            <path d="M12 20v2" />
            <path d="M2 12h2" />
            <path d="M20 12h2" />
          </svg>
        </div>

        {/* Brand name */}
        <p
          style={{
            fontSize: "12px",
            fontWeight: 700,
            letterSpacing: "0.18em",
            color: "#cfa95c",
            textTransform: "uppercase",
            marginBottom: "16px",
          }}
        >
          Intellend
        </p>

        {/* Main heading */}
        <h1
          style={{
            fontSize: "26px",
            fontWeight: 700,
            color: "#065a4e",
            lineHeight: 1.3,
            marginBottom: "16px",
          }}
        >
          We're Upgrading for You
        </h1>

        {/* Divider */}
        <div
          style={{
            width: "48px",
            height: "3px",
            background: "linear-gradient(90deg, #cfa95c, #e8c97a)",
            borderRadius: "2px",
            margin: "0 auto 24px",
          }}
        />

        {/* Body copy */}
        <p
          style={{
            fontSize: "15px",
            color: "#4a5568",
            lineHeight: 1.75,
            marginBottom: "12px",
          }}
        >
          Our platform is currently undergoing scheduled maintenance to bring
          you a faster, more reliable experience.
        </p>
        <p
          style={{
            fontSize: "15px",
            color: "#4a5568",
            lineHeight: 1.75,
            marginBottom: "32px",
          }}
        >
          We'll be back shortly. Thank you for your patience — we appreciate
          your trust in us.
        </p>

        {/* Animated status pill */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "10px",
            background: "rgba(6,90,78,0.07)",
            border: "1px solid rgba(6,90,78,0.15)",
            borderRadius: "100px",
            padding: "10px 20px",
            marginBottom: "32px",
          }}
        >
          {/* Pulsing dot */}
          <span
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              background: "#cfa95c",
              display: "inline-block",
              animation: "pulse-dot 1.4s ease-in-out infinite",
            }}
          />
          <span
            style={{
              fontSize: "13px",
              fontWeight: 600,
              color: "#065a4e",
              letterSpacing: "0.02em",
            }}
          >
            Maintenance in progress{dots}
          </span>
        </div>

        {/* Support note */}
        <div
          style={{
            background: "#f7f9f8",
            borderRadius: "12px",
            padding: "16px 20px",
            border: "1px solid #e2e8e6",
          }}
        >
          <p style={{ fontSize: "13px", color: "#718096", margin: 0 }}>
            Need urgent help?{" "}
            <a
              href="mailto:support@intellendtech.com"
              style={{
                color: "#065a4e",
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              support@intellendtech.com
            </a>
          </p>
        </div>
      </div>

      {/* Footer */}
      <p
        style={{
          marginTop: "32px",
          fontSize: "12px",
          color: "rgba(255,255,255,0.35)",
          letterSpacing: "0.04em",
          position: "relative",
          zIndex: 1,
        }}
      >
        © {new Date().getFullYear()} Intellend Technologies Pvt. Ltd.
      </p>

      {/* Keyframe injection */}
      <style>{`
        @keyframes pulse-dot {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.4; transform: scale(0.75); }
        }
      `}</style>
    </div>
  );
};

export default MaintenancePage;
